import { render } from "./LoginResetSuccess.vue?vue&type=template&id=5c7f1def"
import script from "./LoginResetSuccess.vue?vue&type=script&lang=ts"
export * from "./LoginResetSuccess.vue?vue&type=script&lang=ts"
script.render = render

export default script